import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import {
    getPaymentLinkUrl,
    checkLinkAvailableUrl,
    createPaymentLinkUrl,
    singlePaymentLinkUrl,
    publishLinkUrl,
    plansUrl,
    paymentsUrl
} from '../../shared/helpers/endPoints';
import {
    CHECK_PAYMENT_LINK_AVAILABLE,
    CREATE_PAYMENT_LINK,
    DELETE_SINGLE_PAYMENT_LINK,
    EDIT_SINGLE_PAYMENT_LINK,
    GET_LINK_TRANSACTIONS,
    GET_PAYMENT_LINK,
    GET_PLAN_LNK,
    GET_SINGLE_PAYMENT_LINK,
    PUBLISH_LINK
} from './actionTypes';
import { fetchJSON } from '../../shared/helpers/apiCalls';

import { getSinglePaymentLink, publishToLiveFailure, publishToLiveSuccess, setLinkTransactions, setPaymentLink, setPaymentLinkAvail, setPlansForPaymentLink, setSinglePaymentLink } from './action';

import { setError, setModal, setProcessLoading, setSuccess } from '../utils/action';
import { getStoreLocal } from '../../shared/helpers/utils';
import { authService } from '../../modules/users/services/dependency.injection';

function* callDeleteSinglePaymentLink({ payload: { paymentLinkId, history } }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'DELETE',
            url: singlePaymentLinkUrl(modeType, paymentLinkId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            }
        };

        yield call(fetchJSON, options);

        yield put(setModal({ deletePaymentLinkModal: false }));
        history.push('/payment-link');
        // yield put(setError(''));
        yield put(setModal({ loading: false }));
        yield put(setSuccess('Payment link has been successfully deleted!!'));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setModal({ loading: false }));
    }
}

function* callEditSinglePaymentLink({ payload: { paymentLinkId, values } }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: singlePaymentLinkUrl(modeType, paymentLinkId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },

            data: JSON.stringify(values)
        };

        const response = yield call(fetchJSON, options);

        yield put(setModal({ editChargeModal: false }));
        yield put(setError(''));
        yield put(setModal({ loading: false }));
        yield put(setSinglePaymentLink(response.data));
        yield put(setSuccess('Payment link has been successfully updated!!!'));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setModal({ loading: false }));
    }
}

function* callGetSinglePaymentLink({ payload: { paymentLinkId } }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: singlePaymentLinkUrl(modeType, paymentLinkId),
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setSinglePaymentLink(response.data));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
    }
}

function* callCheckPaymentLinkAvail({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: checkLinkAvailableUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            params: { ...values }
        };

        yield call(fetchJSON, options);
        yield put(setPaymentLinkAvail('Available'));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setPaymentLinkAvail('Not Available'));
    }
}

function* callCreatePaymentLink({ payload: { values, history } }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: createPaymentLinkUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({ ...values })
            // data: JSON.stringify(values)
        };

        const response = yield call(fetchJSON, options);
        yield put(setProcessLoading(false));
        yield put(setModal({ singleChargeModal: false }));
        history.push('/payment-link/' + response.data.id);
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setError(message));
        yield put(setProcessLoading(false));
    }
}

function* callGetPaymentLink({ payload: values }) {
    const access_token = authService.accessToken();
    // const { modeType } = yield select(getMerchantState);
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: getPaymentLinkUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            params: { ...values }
            // data: JSON.stringify(values)
        };

        const response = yield call(fetchJSON, options);

        yield put(setPaymentLink(response.data));
        // yield put(setModal({ addCustomerModal: false }));
        yield put(setError(''));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
    }
}

function* publishLink({ payload: data }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType')
    try {
        const options = {
            method: "POST",
            url: publishLinkUrl(modeType, data.paymentLinkId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: {published: data.value}
        }
        yield call(fetchJSON, options)

        yield put(publishToLiveSuccess(`Successfully ${!data.value ? "Unpublished": "Published"}`))
        yield put(getSinglePaymentLink({paymentLinkId: data.paymentLinkId}))
    } catch (err) {
        yield put(publishToLiveFailure(err.data.error_description))
    }
}

function* callGetPlansForPaymentLink({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: plansUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`
            },
            params: { ...values }
        };

        const response = yield call(fetchJSON, options);

        yield put(setPlansForPaymentLink(response.data));
        yield put(setProcessLoading(false));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;

        // yield put(setError(message));
        yield put(setProcessLoading(false));
    }
}

function* callGetPaymentForPaymentLink({ payload: value }) {
    const access_token = authService.accessToken();

    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: paymentsUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`
            },
            params: value
        };

        yield put(setProcessLoading(true));
        const response = yield call(fetchJSON, options);
        yield put(setLinkTransactions(response.data));
        yield put(setProcessLoading(false));
    } catch (error) {
        setProcessLoading(false)
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
    }
}

export function* watchCallDeleteSinglePaymentLink() {
    yield takeEvery(DELETE_SINGLE_PAYMENT_LINK, callDeleteSinglePaymentLink);
}
export function* watchCallEditSinglePaymentLink() {
    yield takeEvery(EDIT_SINGLE_PAYMENT_LINK, callEditSinglePaymentLink);
}

export function* watchCallGetSinglePaymentLink() {
    yield takeEvery(GET_SINGLE_PAYMENT_LINK, callGetSinglePaymentLink);
}

export function* watchCallCheckPaymentLinkAvail() {
    yield takeEvery(CHECK_PAYMENT_LINK_AVAILABLE, callCheckPaymentLinkAvail);
}

export function* watchCallCreatePaymentLink() {
    yield takeEvery(CREATE_PAYMENT_LINK, callCreatePaymentLink);
}

export function* watchCallGetPaymentLink() {
    yield takeEvery(GET_PAYMENT_LINK, callGetPaymentLink);
}

export function* watchCallPostPublishLink() {
    yield takeEvery(PUBLISH_LINK, publishLink)
}

export function* watchCallGetPlanForPaymentLink() {
    yield takeEvery(GET_PLAN_LNK, callGetPlansForPaymentLink)
}

export function* watchCallGetTransactionForPaymentLink() {
    yield takeEvery(GET_LINK_TRANSACTIONS, callGetPaymentForPaymentLink)
}
function* paymentSaga() {
    yield all([
        fork(watchCallGetPaymentLink),
        fork(watchCallCreatePaymentLink),
        fork(watchCallCheckPaymentLinkAvail),
        fork(watchCallGetSinglePaymentLink),
        fork(watchCallEditSinglePaymentLink),
        fork(watchCallDeleteSinglePaymentLink),
        fork(watchCallPostPublishLink),
        fork(watchCallGetPlanForPaymentLink),
        fork(watchCallGetTransactionForPaymentLink)
    ]);
}
export default paymentSaga;
